import { Component } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { PboButtonDirective } from '@bo-ui/pinata/button';
import { PboEmptyState } from '@bo-ui/pinata/empty-state';
import { SHELL } from './test-ids';

@Component({
  selector: 'amp-error-page',
  template: `
    <pbo-empty-state
      pboIcon="error_outline"
      [pboDescription]="'shell.error.description' | transloco"
      [pboTestId]="testIds.ERROR"
      [pboTitle]="'shell.error.title' | transloco"
    >
      <button pboButton type="button" [attr.data-testid]="testIds.ERROR_RETRY" (click)="reload()">
        {{ 'shell.error.retry' | transloco }}
      </button>
    </pbo-empty-state>
  `,
  styleUrl: './shell-page.scss',
  imports: [PboButtonDirective, PboEmptyState, TranslocoPipe],
})
export class AmpErrorPage {
  readonly testIds = SHELL;

  reload(): void {
    globalThis.location.reload();
  }
}
